// extracted by mini-css-extract-plugin
export default {"dashboard-resources":"styles_dashboard-resources__eMVO8"};